import { render, staticRenderFns } from "./StatusSummaryReport2.vue?vue&type=template&id=cd270214&"
import script from "./StatusSummaryReport2.vue?vue&type=script&lang=ts&"
export * from "./StatusSummaryReport2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports